import { render, staticRenderFns } from "./TheCompanies.vue?vue&type=template&id=d0dbd9e6&"
import script from "./TheCompanies.vue?vue&type=script&lang=js&"
export * from "./TheCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports